const useFooterContent = () => {
  return {}
}

export default useFooterContent
